import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { NzMessageService } from 'ng-zorro-antd'
import { CustomerService } from '../customer/customer.service'
import { ReportSearch } from './report.model'
import { ReportService } from './report.service'

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent implements OnInit {
  constructor(private customerService: CustomerService, private message: NzMessageService, private service: ReportService, private fb: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute) {}
  validateForm: FormGroup
  public pageParams: any = {
    page: 1,
    size: 10,
  }
  public searchConfig = [
    { type: 'timePiker', name: 'time', nick: '选择时间', placeholder: '请选择时间', startAt: 'createAtStart', endAt: 'createAtEnd', disabled: false },
    {
      type: 'select',
      name: 'customerServiceId',
      nick: '选择客服',
      placeholder: '请选择客服',
      data: [],
      disabled: false,
    },
  ]
  isAllChecked: boolean = false
  options = []
  total = 1
  cusAchievementList = []
  loading = false
  sortValue: string | null = null
  sortKey: string = ''
  reportSearch: ReportSearch = null
  cusAchievementMean = null
  cusAchievementTotal = null
  params = null
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((res) => {
      const params = Object.assign({}, new ReportSearch(), res, this.pageParams, { type: 0 })
      console.log(params)
      this.params = params
      this.reportSearch = new ReportSearch(params)
      if (!localStorage.getItem('token')) {
        this.login()
      }
      this.getReport()
      this.getCustomer()
    })
    // this.cusAchievementList = [
    //   {
    //     name: 'sss',
    //   },
    // ]
  }

  submitForm() {
    console.log(this.validateForm.value)
  }

  async getReport() {
    this.loading = true
    console.log(this.reportSearch)
    this.reportSearch.type = '0'
    this.reportSearch.sort = this.sortKey + '' || ''
    if (this.reportSearch.createAtStart == '') {
      this.reportSearch.createAtStart = new Date(new Date().toLocaleDateString()).getTime() - 60 * 60 * 24 * 1000 + ''
      this.reportSearch.createAtEnd = new Date(new Date().toLocaleDateString()).getTime() - 1 + ''
    }

    try {
      const { data } = await this.service.getReport(this.reportSearch)
      const { cusAchievementList, customerServiceMap, cusAchievementMean, cusAchievementTotal } = data
      cusAchievementList.forEach((item) => {
        item.customer = customerServiceMap[item.customerServiceId]
        item.checked = false
      })
      this.cusAchievementMean = cusAchievementMean
      this.cusAchievementList = cusAchievementList
      this.cusAchievementTotal = cusAchievementTotal
      this.loading = false
      console.log('报表数据--》', data)
    } catch (error) {
      console.log(error)
      this.message.error(error.message)
      this.loading = false
    }
  }
  async getCustomer() {
    try {
      const params = {}
      const { data } = await this.service.getCustomer(params)
      this.options = []
      this.options.push({
        value: '',
        label: '全部客服',
      })
      data.forEach((item) => {
        this.options.push({
          value: item.id,
          label: item.name,
        })
      })
      this.searchConfig[1].data = this.options
    } catch (error) {
      this.message.error(error.message)
    }
  }
  sort(sort: { key: string; value: string }): void {
    this.sortKey = sort.value == 'descend' ? sort.key : parseInt(sort.key) * -1 + ''
    this.getReport()
  }
  checkNoAll() {
    console.log(this.isAllChecked)
    // this.isAllChecked = !this.isAllChecked
    console.log(this.isAllChecked)
    this.cusAchievementList.forEach((item) => {
      item.checked = this.isAllChecked
    })
  }
  checkNo(index: number) {
    // this.cusAchievementList[index].checked = true
    console.log(this.cusAchievementList)
  }
  searchData(reset: boolean = false): void {
    this.loading = true
    if (reset) {
      this.pageParams.page = 1
    }
    this.loading = false
  }

  async login() {
    try {
      const params = {
        exten: this.params.exten,
        token: this.params.token,
        tokenId: this.params.tokenId,
      }
      const { data } = await this.customerService.login(params)
      localStorage.setItem('merchantId', data.merchants[0].id)
      localStorage.setItem('token', data.token)
    } catch (error) {
      this.message.error(error.message)
    }
  }

  async export(type: string) {
    try {
      // let params = {
      //   excelIds: [],
      //   excel: true,
      //   type: 0,
      // }
      let params = JSON.parse(JSON.stringify(this.reportSearch)) 
      let ids = []
      params.excel = true
      if (type === 'select') {
        ids = this.cusAchievementList.map((item) => {
          if (item.checked) {
            return item.id
          }
        })
        console.log(ids);
        params['excelIds'] = ids
        params.size = '10'
        if(ids.length === 0){
          this.message.warning("请勾选数据")
          return
        }
      }else if (type === 'all'){
        params['excelIds'] = []
        params.size = '9999'
      }else if (type === 'page'){
        params.size = '10'
      }
      console.log('导出参数--->',params);
      
      const { data } = await this.service.getReport(params)
      console.log(data)
      if (data.url) {
        const url = window.location.protocol + '//' + window.location.host + data.url
        window.open(url)
        console.log(url)
      } else {
        this.message.error('下载文件不存在')
      }
    } catch (error) {
      console.log('error--->', error)
      this.message.error(error.message)
    }
  }
}
